import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/Button";
import { useState } from "react";
import SendFormModal from "./SendFormModal";

interface NavigationBarProps {
  currentDate: Date;
  onDateChange: (newDate: Date) => void;
}

const NavigationBar = ({ currentDate, onDateChange }: NavigationBarProps) => {
  const navigate = useNavigate();
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [isOpenFormModalOpen, setIsOpenFormModalOpen] = useState(false);

  const formatDate = (date: Date) =>
    date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    });

  const handlePreviousDate = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - 1);
    onDateChange(newDate);
  };

  const handleNextDate = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + 1);
    onDateChange(newDate);
  };

  return (
    <div className="mb-6 flex items-center justify-between rounded-2xl bg-white p-4 shadow-sm border border-[#E7E4F8] hover:shadow-md transition">
      {/* Date Navigation */}
      <div className="flex items-center gap-3">
        <button
          onClick={handlePreviousDate}
          className="h-8 w-8 flex items-center justify-center rounded-full border border-[#BBB9F3] text-[#402B69] hover:bg-[#F8F7FC] transition"
        >
          <ChevronLeft size={18} />
        </button>

        <h2 className="text-lg font-semibold text-[#402B69]">
          {formatDate(currentDate)}
        </h2>

        <button
          onClick={handleNextDate}
          className="h-8 w-8 flex items-center justify-center rounded-full border border-[#BBB9F3] text-[#402B69] hover:bg-[#F8F7FC] transition"
        >
          <ChevronRight size={18} />
        </button>
      </div>

      {/* Actions */}
      <div className="flex gap-3">
        <Button
          variant="outline"
          onClick={() => setIsOpenFormModalOpen(true)}
          className="
      px-6 
      text-[#6E3FA9] 
      bg-white 
      hover:bg-[#F5F2FF] 
      hover:text-[#402B69]
      font-semibold 
      transition
    "
        >
          Open Form
        </Button>

        <Button
          variant="outline"
          onClick={() => setIsSendModalOpen(true)}
          className="
      px-6 
      text-[#6E3FA9] 
      bg-white 
      hover:bg-[#F5F2FF] 
      hover:text-[#402B69]
      font-semibold 
      transition
    "
        >
          Send
        </Button>

        <Button
          onClick={() => navigate("/form-templates")}
          className="px-6 bg-[#885ABB] hover:bg-[#6E3FA9] text-white font-semibold shadow-sm hover:shadow-md transition"
        >
          Form Templates
        </Button>
      </div>

      <SendFormModal
        open={isSendModalOpen}
        onClose={() => setIsSendModalOpen(false)}
      />

      <SendFormModal
        open={isOpenFormModalOpen}
        onClose={() => setIsOpenFormModalOpen(false)}
        title="Open Customer Form"
        submitLabel="Open Form"
        endpoint="/admin/consultations/open-form"
        openEncodedFormRouteInNewTab
      />
    </div>
  );
};

export default NavigationBar;
